import { Navigate } from 'react-router-dom';

import StoresList from '~/UI/components/organisms/StoresList';
import FullPageLoader from '~/UI/components/templates/FullPageLoader';
import { LOCAL_STORAGE_KEY } from '~/core/constants';
import { useRetailerSettings } from '~/core/hooks/useRetailerSettings';
import { useEstimateContext } from '~/legacy/easy-estimator-page/context/estimateContext';
import { useAppSelector } from '~/redux/hooks';
import { selectLoadEstimateCode } from '~/redux/slices/estimate';
import { RouteEnum } from '~/redux/slices/route/route.types';

const StorePage = (): JSX.Element => {
  const { isFetchingEstimate, fetchedEstimate } = useEstimateContext();
  const loadEstimateCode = useAppSelector(selectLoadEstimateCode);
  const { isOnlineRetailer } = useRetailerSettings();
  const loadEstimateParam = new URL(window.location.href).searchParams.get(
    LOCAL_STORAGE_KEY.LOAD_ESTIMATE
  );
  const isOfflineRetailer = !isOnlineRetailer;

  if (loadEstimateParam && !fetchedEstimate) {
    return (
      <Navigate
        to={`${RouteEnum.THANK_YOU}?${LOCAL_STORAGE_KEY.LOAD_ESTIMATE}=${loadEstimateParam}`}
        replace
      />
    );
  }

  if (isFetchingEstimate) {
    return <FullPageLoader />;
  }

  // Disable store selection only for online retailers loading saved estimates (via ?loadEstimate=<uuid>)
  // Offline retailers should be able to select stores even when loading a saved estimate
  // because they need to choose from nearby physical locations
  // ZIP is disabled for both online and offline when loading an estimate (pre-populated from lead data)
  return (
    <StoresList
      disabled={!!loadEstimateCode && isOnlineRetailer}
      isZipDisabled={!!loadEstimateCode && isOfflineRetailer}
    />
  );
};

export default StorePage;
